var _mask, _rect, _mask2, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBattery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "new_battery_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.455,
    y: 2.727,
    width: 19.091,
    height: 12.273,
    rx: 1.364
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.455,
    y: 2.727,
    width: 19.091,
    height: 12.273,
    rx: 1.364,
    stroke: "#e95832",
    strokeWidth: 3,
    mask: "url(#new_battery_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "new_battery_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.545,
    width: 10.909,
    height: 4.091,
    rx: 1.364
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.545,
    width: 10.909,
    height: 4.091,
    rx: 1.364,
    stroke: "#e95832",
    strokeWidth: 3,
    mask: "url(#new_battery_svg__b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.09 8.182v2.727M12.727 9.546h2.727M4.545 9.545h2.728",
    stroke: "#e95832",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/media/new_battery.72aeb504.svg";
export { SvgNewBattery as ReactComponent };